import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { ServerResponseCurrencyKeys, ServerResponseKeys } from '../../../../api/Constants';
import { getObjectValues, hasObjectValues } from '../../../../utils/object';
import { setCoin, setLoyalty, setPremium } from '../../../actions/extras';
import { setActionCommand, setActionCommandLoading } from '../../../slices/actionCommands/actionCommands';
import { setCurrentLevelBonusCoins, setLevel, setMaxBet, setNextLevelBonusCoins, setNextLevelMaxBet, setPreviousLevelBonusCoins } from '../../../slices/level/level';
import { setXpRequired, setXp } from '../../../slices/xp/xp';
import store from '../../../store';
import { validateActionCommand } from './validations';

var handleBalance = function handleBalance(balance) {
  store.dispatch(setCoin(parseInt(balance[ServerResponseCurrencyKeys.COINS])));
  store.dispatch(setPremium(balance[ServerResponseCurrencyKeys.PREMIUM]));
  store.dispatch(setLoyalty(parseInt(balance[ServerResponseCurrencyKeys.LOYALTY])));
};

var handleProgression = function handleProgression(progression) {
  store.dispatch(setLevel(progression.level));
  store.dispatch(setXp(progression.xp));
  store.dispatch(setXpRequired(progression.xpneeded));
  store.dispatch(setMaxBet(progression.maxbet));
  store.dispatch(setNextLevelMaxBet(progression.nextLevelMaxbet));
  store.dispatch(setNextLevelBonusCoins(progression.nextLevelCoins));
  store.dispatch(setCurrentLevelBonusCoins(progression.coins));
  store.dispatch(setPreviousLevelBonusCoins(progression.previousLevelCoins));
};

export var handleActionsCommands = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(actions) {
    var actionsValidated;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store.dispatch(setActionCommandLoading(true));
            _context.next = 3;
            return validateActionCommand(actions);

          case 3:
            actionsValidated = _context.sent;
            if (actionsValidated.length > 0) store.dispatch(setActionCommand({
              actions: actionsValidated
            }));
            store.dispatch(setActionCommandLoading(false));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleActionsCommands(_x) {
    return _ref.apply(this, arguments);
  };
}();

var handleInterceptors = function handleInterceptors(data) {
  if (data[ServerResponseKeys.CURRENCY_BALANCES]) handleBalance(data[ServerResponseKeys.CURRENCY_BALANCES]);
  if (data[ServerResponseKeys.PROGRESSION]) handleProgression(data[ServerResponseKeys.PROGRESSION]);
  if (data[ServerResponseKeys.ACTIONS_COMANDS] && hasObjectValues(data[ServerResponseKeys.ACTIONS_COMANDS])) handleActionsCommands(getObjectValues(data[ServerResponseKeys.ACTIONS_COMANDS]));
};

export default handleInterceptors;